// extracted by mini-css-extract-plugin
export default {"container":"PieceRendererViewOriginalImage_container__Tcehx"};